import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as Moment from 'moment-timezone';
import * as React from 'react';
import * as DateTime from 'react-datetime';
import { Prompt, withRouter } from 'react-router-dom';
import 'react-widgets/dist/css/react-widgets.css';
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import { EButton, EInput } from 'src/Components/EInput';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { ISurvey, ITest } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import { decimalPlaces } from '../../../../../UtilityFunctions/DecimalPlaces';
import DataTable from '../../../../DataTable';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';






interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class Survey extends React.Component {
    public props: any;
    private dataSet: IList;
    private test: ITest = new ITest();
    public TestsStore: any;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;
    private surveyItem: ISurvey = new ISurvey();

    public state = {
        dataSet: this.dataSet,
        editing: false,
        isDirty: false,
        modal: false,
        rowIndex: 0,
        saveClicked: false,
        surveyItem: this.surveyItem,
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;

        this.handleDelete = this.handleDelete.bind(this);

        this.handleCancel = this.handleCancel.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateTimeChange = this.handleDateTimeChange.bind(this);

        this.clearDisposers = this.clearDisposers.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            this.setState({
                test: toJS(this.props.stores.TestsStore.test),
                well: toJS(this.props.stores.WellsStore.well)
            }, () => {
                this.formatDataTable();
            });
        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
                this.setState({
                test
            }, () => {
                this.formatDataTable();
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    private formatDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'MD',
            'TVD',
            'Inclination',
            'Azimuth',
            'Date',
            'Time',
            'Report'
        ];
        if ( this.state.test.surveys ) {
            this.state.test.surveys.map((survey: ISurvey, index: number) => {
                survey.preSurveyDateTime = Moment.unix(survey.surveyDateTime).tz(this.state.well.timeZoneName);
                const newObject = [
                    {
                        content: survey.depthMD
                    },
                    {
                        content: survey.depthTVD
                    },
                    {
                        content: survey.inclination
                    },
                    {
                        content: survey.azimuth
                    },
                    {
                        content: survey.preSurveyDateTime.format('L')
                    },
                    {
                        content: survey.preSurveyDateTime.format('LT')
                    },
                    {
                        content: Moment.unix(Number(survey.testDateTime)).tz(this.state.well.timeZoneName).format("MMM DD YYYY - h:mm a")
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        
        this.setState({
            dataSet: listStructure
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private handleDelete(index: number) {
        const test = this.state.test;
        const items = test.surveys;
        items.splice(index,1);
        test.surveys = items;
        this.setState({
            isDirty: true,
            test
        });
        this.formatDataTable();
    }

    private handleEdit = (index: number) => {
        const mySurvey = DeepCopy(this.state.test.surveys[index]);
        mySurvey.preSurveyDateTime = Moment.unix(mySurvey.surveyDateTime).tz(this.state.well.timeZoneName);
        this.setState({
            editing: true,
            rowIndex: index,
            surveyItem: mySurvey
        });
        this.toggleModal();
    }


    private handleSave = (addAnother: boolean) => () => {
        const test = this.state.test;
        const pushSurvey = this.state.surveyItem;
        if (pushSurvey.preSurveyDateTime.unix) {
            pushSurvey.surveyDateTime = pushSurvey.preSurveyDateTime.unix();
            pushSurvey.testDateTime = this.state.test.testDate.toString();
        } else {
            pushSurvey.surveyDateTime = Moment.tz(this.state.well.timeZoneName).unix();
        }
        if ( ! this.state.editing ) {
            test.surveys.unshift(pushSurvey);
        }
        test.surveys.sort((a, b,) => Number(b.depthMD) - Number(a.depthMD));
        const mySurvey = new ISurvey();
        mySurvey.preSurveyDateTime = Moment.tz(this.state.well.timeZoneName);
        this.setState({
            editing: false,
            isDirty: true,
            surveyItem: mySurvey,
            test,
        }, () => {
            this.formatDataTable();
        });
        if (!addAnother) {
            this.toggleModal();
        }
    }

    private handleCancel() {
        const mySurvey = new ISurvey();
        this.setState({
            editing: false,
            surveyItem: mySurvey,
        });

        this.toggleModal();
    }

    private toggleModal() {
        if ( this.state.modal ) {
            const surveyItem = new ISurvey();
            surveyItem.preSurveyDateTime = Moment.tz(this.state.well.timeZoneName);
            this.setState({
                editing: false,
                modal: !this.state.modal,
                surveyItem
            });
        } else {
            if(!this.state.surveyItem.surveyDateTime) {
                this.state.surveyItem.preSurveyDateTime = Moment.tz(this.state.well.timeZoneName);
            }
            this.setState({
                modal: !this.state.modal,
                surveyItem: this.state.surveyItem,
            });
        }
    }

    private handleInputChange(event: any) {
        if ( ! this.state.editing ) {
            const surveyItem = this.state.surveyItem;
            surveyItem[event.target.name] = event.target.value;
            this.setState({
                surveyItem
            });
        } else {
            const surveyItem = this.state.test.surveys[this.state.rowIndex];
            surveyItem[event.target.name] = event.target.value;
            this.setState({
                surveyItem
            });
        }
    }

    private handleKopEoc = (event:any) => {
        const test = this.state.test;
        test[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            test
        });
    }

    private calcLateral = () => {
        if (this.state.test.eocMD === '' || !isFinite(this.state.test.eocMD)) {
            return '';
        }

        return this.state.test.depthMD - this.state.test.eocMD;
    }
    private handleDateTimeChange(value: any) {
        let surveyItem;
        if ( ! this.state.editing ) {
            surveyItem = this.state.surveyItem;
        } else {
            surveyItem = this.state.test.surveys[this.state.rowIndex];
        }
        surveyItem.preSurveyDateTime = value;
        if (value.unix) {
            surveyItem.surveyDateTime = value.unix();
        }
        this.setState({
            surveyItem
        });
    }

    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;

        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/holegeometry/casingandinterval');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/drillingpump');
        }
    }

    private checkDecimalPlaces = (value: any, maxDecimal: number) => () => {
        return decimalPlaces(value) > maxDecimal;
    }

    private saveSurveyDisabled = () => {
        return this.checkDecimalPlaces(! this.state.editing ?
        this.state.surveyItem.inclination :
        this.state.test.surveys[this.state.rowIndex].inclination, 2)();
    }

    public render() {
        const disableWellStatus = this.WellsStore.well && this.WellsStore.well.wellStatus !== 'Active';
        return(
            <div className="Survey">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md={4}>
                        <Form className="form-validated">
                            <div className="data-table-component">
                                
                                <Table>
                                    <thead>
                                        <tr>
                                            <th />
                                            <th style={{textAlign: 'center'}}>
                                                MD
                                            </th>
                                            <th style={{textAlign: 'center'}}>
                                                TVD
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>
                                                KOP
                                            </th>
                                            <td>
                                                <EInput 
                                                    type="text"
                                                    data-validation="integer"
                                                    name="kopMD"
                                                    value={this.state.test.kopMD}
                                                    onChange={this.handleKopEoc}
                                                />
                                            </td>
                                            <td>
                                                <EInput 
                                                    type="text"
                                                    data-validation="integer"
                                                    name="kopTVD"
                                                    value={this.state.test.kopTVD}
                                                    onChange={this.handleKopEoc}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                EOC
                                            </th>
                                            <td>
                                                <EInput 
                                                    type="text"
                                                    data-validation="integer"
                                                    name="eocMD"
                                                    value={this.state.test.eocMD}
                                                    onChange={this.handleKopEoc}
                                                />
                                            </td>
                                            <td>
                                                <EInput 
                                                    type="text"
                                                    data-validation="integer"
                                                    name="eocTVD"
                                                    value={this.state.test.eocTVD}
                                                    onChange={this.handleKopEoc}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Lateral
                                            </th>
                                            <td>
                                                <EInput 
                                                    type="text"
                                                    data-validation="integer"
                                                    name="lateral"
                                                    value={this.calcLateral()}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Form>
                    </Col>
                </Row>
                <DataTable
                    list={this.state.dataSet}
                    onDelete={this.handleDelete}
                    onEdit={this.handleEdit}
                    onNew={{
                        callback: this.toggleModal,
                        text: 'Add Survey'
                    }}
                    disableEditing={disableWellStatus}
                />
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>{this.state.editing ? 'Edit Survey' : 'Add New Survey'}</ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                            <Col md="6">
                                    <FormGroup className="required">
                                        <Label>MD</Label>
                                        <EInput
                                            type="text"
                                            name="depthMD"
                                            id="depthMD"
                                            data-validation="decimal"
                                            required={true}
                                            value={ ! this.state.editing ?
                                                this.state.surveyItem.depthMD :
                                                this.state.test.surveys[this.state.rowIndex].depthMD
                                            }
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>TVD</Label>
                                        <EInput
                                            type="text"
                                            name="depthTVD"
                                            id="depthTVD"
                                            data-validation="decimal"
                                            required={true}
                                            value={ ! this.state.editing ?
                                                this.state.surveyItem.depthTVD :
                                                this.state.test.surveys[this.state.rowIndex].depthTVD
                                            }
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Inclination</Label>
                                        <EInput
                                            type="text"
                                            name="inclination"
                                            id="inclination"
                                            data-validation="decimal"
                                            required={true}
                                            value={ ! this.state.editing ?
                                                this.state.surveyItem.inclination :
                                                this.state.test.surveys[this.state.rowIndex].inclination
                                            }
                                            onChange={this.handleInputChange}
                                            errorCallback={{
                                                callback: this.checkDecimalPlaces( ! this.state.editing ?
                                                    this.state.surveyItem.inclination :
                                                    this.state.test.surveys[this.state.rowIndex].inclination, 2),
                                                message: 'Value has a maximum of 2 decimal places.'
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Azimuth</Label>
                                        <EInput
                                            type="text"
                                            name="azimuth"
                                            id="azimuth"
                                            required={true}
                                            value={ ! this.state.editing ?
                                                this.state.surveyItem.azimuth :
                                                this.state.test.surveys[this.state.rowIndex].azimuth
                                            }
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup className="required">
                                        <Label>Date</Label>
                                        <DateTime
                                            value={ this.state.surveyItem.preSurveyDateTime }
                                            onChange={this.handleDateTimeChange}
                                            inputProps={{disabled: this.state.well.wellStatus !== 'Active'}}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.handleCancel}>Cancel</Button>
                        <EButton color="primary" disabled={this.saveSurveyDisabled()} onClick={this.handleSave(false)}>Update</EButton>
                        {
                            !this.state.editing && 
                            <EButton color="primary" disabled={this.saveSurveyDisabled()} onClick={this.handleSave(true)}>Add Another</EButton>
                        }
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

export default withRouter(Survey);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/HoleGeometry/Survey/Survey.tsx